import {Element} from "types/Element";
import {dateTime} from "services/date";
import deserializeFile from "services/ngage/deserializers/file";

/**
 * Transform the given element by deserializing object properties
 *
 * @internal
 * @param element
 */
export default function deserializeElement(element: any): Element {
    element.featured_at = dateTime(element.featured_at)
    element.created_at = dateTime(element.created_at)
    element.updated_at = dateTime(element.updated_at)

    if(element.media) {
        element.media = element.media.map(deserializeFile)
    }

    return element;
}